var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{ref:"container",staticClass:"overflow-y-auto pa-0",staticStyle:{"border-top":"1px solid #ddd"}},_vm._l((_vm.items),function(item,index){return _c('v-row',{key:item.raw.codeId},[_c('address-item-simple-card',{attrs:{"item":item},on:{"pick":pick => _vm.$emit('pick', pick)}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }